import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ServiceAppModels } from 'src/app/models/serviceapp-models';

@Component({
  selector: 'app-mail-form',
  templateUrl: './mail-form.component.html',
  styleUrls: ['./mail-form.component.scss']
})
export class MailFormComponent implements OnInit {

  @Output() close = new EventEmitter<any>();
  @Output() submit = new EventEmitter<any>();
  @Input() formGroupMailContent: UntypedFormGroup;

  fldEmpfaengerKey: string = "fldEmpfaenger";
  fldBetreffKey: string = "fldBetreff";
  fldNachrichtKey: string = "fldNachricht";

  private mailTemplate: ServiceAppModels.MailTemplate = {
    empfaenger: '',
    betreff: '',
    nachricht: ''
  }

  constructor(public dialogRef: MatDialogRef<MailFormComponent>,) {

    this.formGroupMailContent = new UntypedFormGroup({
      fldEmpfaenger: new UntypedFormControl(),
      fldBetreff: new UntypedFormControl(),
      fldNachricht: new UntypedFormControl(),
    });
   }

  ngOnInit(): void {
    this.changePosition();
  }

  changePosition() {
    this.dialogRef.updatePosition({ top: '5px' });
  }

  send(): void {
    this.mailTemplate = {
      empfaenger: this.formGroupMailContent.controls[this.fldEmpfaengerKey].value,
      betreff: this.formGroupMailContent.controls[this.fldBetreffKey].value,
      nachricht: this.formGroupMailContent.controls[this.fldNachrichtKey].value,
    }
    
    this.dialogRef.close(this.mailTemplate);
  }

}
